import { partition } from 'lodash';

export default function partitionKeys(node) {
  if (node === true) {
    return { route: [], metadata: [] };
  }

  const [route, metadata] = partition(
    Object.keys(node), key => key.indexOf('_') !== 0,
  );

  return { route, metadata };
}
